module.exports = __webpack_public_path__ + "img/tapak-semaian-kelapa-tacunan-bt-14.03e22bca.jpeg";